import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Modal} from 'react-bootstrap';
import NewRoleModal from './newRoleModal';

import * as Actions from 'actions';

class ExistingRoles extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        	show_add_role_modal : false
        }

        this.createRoles = this.createRoles.bind(this);
        this.handleRolesClick = this.handleRolesClick.bind(this);
        this.showNewRoleModal = this.showNewRoleModal.bind(this);
        this.hideNewRoleModal = this.hideNewRoleModal.bind(this);
    }

    createRoles(role) {
    	let user = this.props.users.user;

    	if((user && user.role_current) && (user.role_current._id !== role._id)) {
	    	var className;
	    	if (this.props.roleManagement.selectedRole === role._id)
	    		className = 'btn btn-primary roles-button';
	    	else
	    		className = 'btn btn-default roles-button';
	    	return (
	  			<div 
	  				key={role._id}
	  				className={className}
	  				id={role._id}
	    			onClick={this.handleRolesClick}>
	  				{role.name}
	  			</div>
	  		);
	    }
    }

    handleRolesClick(event) {
    	this.props.handleClickRole(event.target.id)
    }

    showNewRoleModal() {
    	this.setState({show_add_role_modal : true})
    }

    hideNewRoleModal() {
    	this.setState({show_add_role_modal : false})
    }

    render() {
        return (
        	<div className='existing-roles-container'>
        		<Modal 
        			show={this.state.show_add_role_modal} 
        			onHide={() => {this.setState({show_add_role_modal : false})}}
      				>
      				<NewRoleModal hide={() => {this.setState({show_add_role_modal : false})}}/>
      			</Modal>
        		{/*(() => {
        			if (this.state.show_add_role_modal)
        				return <NewRoleModal hideModal={this.hideNewRoleModal}/>
        		})()*/}
        		<h3 style={{display : 'inline-block'}}>Existing Roles</h3>
        		<br/>
        		<div>
	        		{(() => {
	        			if (this.props.roleManagement.roles) {
	        				return (
	        					<div>
	        						{(this.props.users.user.is_admin && this.props.users.proxy_account) ?
	        							this.props.users.tmp_user_roles.map(this.createRoles) :
	        							this.props.roleManagement.roles.map(this.createRoles)}
	        						<div 
	        							id='add-new-role-button'
					        			className='btn btn-primary roles-button'
					        			onClick={this.showNewRoleModal}>
					        			<div className='fa fa-plus' />
					        		</div>
	        					</div>
        					);
	        			}
	        		})()}
	        	</div>
        	</div>
        );
    }
}

function mapStateToProps({roleManagement, users}) {
	return {
		roleManagement,
		users
	}
}

export default connect(mapStateToProps, Actions)(ExistingRoles)


// WEBPACK FOOTER //
// ./src/browser/components/roleManagement/existingRoles.js